import React from 'react'

import ConsoleDialog from './ConsoleDialog'

export default function MarketplaceGuideDialog({ show, onClose, onCreate, onDocs, onDemo, t }) {
    const benefits = [
        ['fa-store', t('专属交易页面'), t('集中展示在售 NFT、价格与成交记录，方便持有人发现和交易。')],
        ['fa-water', t('提升 NFT 流动性'), t('持有人可以自主挂单和购买，为 NFT 提供持续流通的入口。')],
        ['fa-coins', t('灵活结算与分佣'), t('支持常用结算资产，并可设置项目方分佣与收款钱包。')],
    ]

    return <ConsoleDialog
        show={show}
        onClose={onClose}
        title={t('创建 NFT 交易市场')}
        description={t('为 NFT 提供专属交易入口')}
        icon="fa-store"
        closeLabel={t('关闭')}
        className="marketplace-guide-dialog"
        footer={<>
            <button type="button" className="console-button is-secondary" onClick={onDocs}><i className="fa fa-book-open" /> {t('查看文档')}</button>
            <button type="button" className="console-button is-secondary" onClick={onDemo}><i className="fa fa-external-link-alt" /> {t('查看演示站点')}</button>
            <button type="button" className="console-button is-primary" onClick={onCreate}><i className="fa fa-plus" /> {t('去创建')}</button>
        </>}
    >
        <div className="marketplace-guide">
            <div className="marketplace-guide__intro">
                <span className="marketplace-guide__mark"><i className="fa fa-chart-line" /></span>
                <div>
                    <strong>{t('让您的 NFT 更容易被发现和交易')}</strong>
                    <p>{t('创建后，项目将拥有独立的 NFT 交易页面，用户可以完成挂单、购买和订单管理。')}</p>
                </div>
            </div>
            <div className="marketplace-guide__benefits">
                {benefits.map(([icon, title, description]) => <article key={title}>
                    <i className={`fa ${icon}`} />
                    <div><strong>{title}</strong><p>{description}</p></div>
                </article>)}
            </div>
            <p className="marketplace-guide__note"><i className="fa fa-info-circle" /> {t('创建前可先查看文档或演示站点，了解完整操作流程。')}</p>
        </div>
    </ConsoleDialog>
}
